<template>
  <div class="2can">
    <div class="shop_banner_area mb-30">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="shop_banner_thumb">
              <img src="/img/checkout.jpg" alt="" />
            </div>
            <div class="page_title">
              <h1>Оформление заказа</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="breadcrumbs_area mt-30 mb-30">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="breadcrumb_content">
              <ul>
                <li><router-link :to="'/'">Главная</router-link></li>
                <li>Оформление заказа</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mb-45">
      <div class="checkout_form">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <form action="#">
              <h3>Детали заказа</h3>
              <div class="row">
                <div class="col-lg-6 mb-20">
                  <label>Фамилия <span>*</span></label>
                  <input type="text" />
                </div>
                <div class="col-lg-6 mb-20">
                  <label>Имя <span>*</span></label>
                  <input type="text" />
                </div>
                <div class="col-12 mb-20">
                  <label>Адрес доставки <span>*</span></label>
                  <input type="text" />
                </div>
                <div class="col-lg-6 mb-20">
                  <label>Телефон <span>*</span></label>
                  <input type="text" />
                </div>
                <div class="col-lg-6 mb-20">
                  <label>Адрес Email <span>*</span></label>
                  <input type="text" />
                </div>
                <div class="col-12">
                  <div class="order-notes">
                    <label for="order_note">Комментарий к заказу</label>
                    <textarea id="order_note" placeholder="Добавьте ваши комментарии к заказу."></textarea>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-lg-6 col-md-6">
            <form action="#">
              <h3>Ваш заказ</h3>
              <div class="order_table table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>Товар</th>
                      <th>Сумма</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in cart" :key="item.code">
                      <td>
                        {{ item.title }} <strong> × {{ item.amount }}</strong>
                      </td>
                      <td>{{ item.price * item.amount }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="order_total">
                      <th>ИТОГО</th>
                      <td>
                        <strong>{{ this.$store.getters.cartTotalPrice }} р.</strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div class="payment_method">
                <div class="order_button text-right">
                  <button type="submit">Оформить</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <MakeCall title="Позвоните мне" icon="telephone"></MakeCall>
  </div>
</template>

<script>
import MakeCall from "../components/MakeCall"
export default {
  name: "Checkout",
  components: {
    MakeCall,
  },
  data: () => ({
    cart: [],
  }),
  methods: {
    removeItem(code) {
      this.$store.dispatch("removeFromCart", code)
    },
  },
  computed: {
    getLink() {
      return (code) => `/shop/${code}`
    },
  },
  mounted() {
    this.cart = this.$store.state.cart
  },
}
</script>
